import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M8.57143 15.1667L6.5 13.5L7.44603 15.5209C7.93214 16.5593 8.70557 17.4366 9.67479 18.0491L10.1748 18.3651C11.8 19.3921 13.8188 19.5782 15.6042 18.8656L20 17.1111V14.6111L15.5606 16.4852C13.8011 17.228 11.7932 17.0887 10.1531 16.1103L8.57143 15.1667Z'
            fill='currentColor'
        />
        <path
            d='M4.02237 10.4851L1 12.5L3.48276 11.8229C5.37353 11.3072 7.39698 11.7475 8.90257 13.0021L9.56316 13.5526C11.3547 15.0456 13.849 15.3652 15.959 14.3722L21 12V7.5L15.4617 11.0836C13.6969 12.2255 11.3966 12.0973 9.76974 10.7661C8.1239 9.41956 5.79174 9.30551 4.02237 10.4851Z'
            fill='currentColor'
        />
        <path
            d='M1.34872 8.30987L0 8.16682L1.15815 8.68156C2.31607 9.19619 3.64982 9.12883 4.75 8.50016C5.85018 7.87148 7.18393 7.80412 8.34185 8.31875L11 9.50016V7.50016L8.82859 6.69593C7.38298 6.16052 5.7627 6.41915 4.5556 7.37799C3.65022 8.09716 2.49853 8.43183 1.34872 8.30987Z'
            fill='currentColor'
        />
    </svg>
);

export const StreamIcon = styled(Icon)({});
